import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from '../importModal/ImportModal.css';

class ImportModalError extends React.Component {
  render() {
    const {
      messageError,
      onShow,
      onClickTryBtn,
      onClickCancelBtnError,
      onClickDownloadTemplate,
    } = this.props;

    return (
      <div>
        <Modal
          show={onShow}
          bsClass="modal-import modal"
          id="modalImportError"
          backdrop
        >
          <Modal.Header>
            <Modal.Title>Import Errors</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-body no-padding">
            <div className="customer-body">
              <div className="customer-scroll">
                <div className="mk-col-right-box right-modal-customer">
                  {messageError && (
                    <div className={`${styles.description} text-left`}>
                      We Found {messageError.length} errors in your file. Please
                      correct them and re-upload your file.
                    </div>
                  )}
                  {!messageError && (
                    <div className={`${styles.description} text-left`}>
                      Do not change the format of the template. Please{' '}
                      <a
                        className="download-our-template"
                        onClick={onClickDownloadTemplate}
                      >
                        re-download
                      </a>{' '}
                      the template and use the original format.
                    </div>
                  )}
                  {messageError && (
                    <div>
                      <ol>
                        {messageError.map((message, i) => {
                          return (
                            <li key={i}>
                              <span className={styles['list-type']}>
                                {i + 1}.{' '}
                              </span>
                              <strong className="text-error">
                                <span className="text-red">{message}</span>
                              </strong>
                            </li>
                          );
                        })}
                      </ol>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-default pull-left"
              onClick={onClickCancelBtnError}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary pull-right"
              onClick={onClickTryBtn}
            >
              Try Again
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ImportModalError;
